import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { FolderIcon, Tag } from '@mercai/clever'

import { CardInfo } from '@/components'

import { SupplyPaymentStatusEnum } from '@/types'
import { CardSupplyOrderDetailProps } from './card-supply-order-detail.type'

export const CardSupplyOrderDetail = ({
  data,
  isLoading,
}: CardSupplyOrderDetailProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenSupplyOrderDetail')

  const statuses: Record<SupplyPaymentStatusEnum, ReactNode> = {
    pending: (
      <Tag variant="warning" model="light" size="small">
        {tEnums('supply_order_payment_status_pending')}
      </Tag>
    ),
    payment_required: (
      <Tag variant="warning" model="light" size="small">
        {tEnums('supply_order_payment_status_payment_required')}
      </Tag>
    ),
    paid: (
      <Tag variant="success" model="light" size="small">
        {tEnums('supply_order_payment_status_paid')}
      </Tag>
    ),
    cancelled: (
      <Tag variant="danger" model="light" size="small">
        {tEnums('supply_order_payment_status_cancelled')}
      </Tag>
    ),
  }

  return (
    <CardInfo
      icon={<FolderIcon />}
      title={t('cardSupplyOrderDetailTitle')}
      isLoading={isLoading}
      items={[
        {
          label: t('cardSupplyOrderDetailPaymentStatus'),
          value: data?.payments?.[0]?.status
            ? statuses[data.payments?.[0]?.status]
            : '-',
        },
        {
          label: t('cardSupplyOrderDetailPurchaseOrderCode'),
          value: data?.supplyQuotation?.purchaseOrderCode || '-',
        },
        {
          label: t('cardSupplyOrderDetailObservations'),
          value: data?.observation || '-',
        },
      ]}
    />
  )
}
